import styled from "styled-components";
import propTypes from "@styled-system/prop-types";
import themeGet from "@styled-system/theme-get";
import { space } from "styled-system";
import { lighten } from "../../../utilities/color";

const ButtonLinkStyle = styled.button`
  color: ${themeGet("colors.primary.color", "#1b4aa8")};
  text-decoration: none;
  background-color: ${themeGet("colors.transparent", "transparent")};
  box-sizing: border-box;
  cursor: pointer;
  border: none;
  padding: ${themeGet("space.0", "0")}px;
  
  &:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: 1px;
    border: none;
  }
  
  &:hover {
    text-decoration: underline;
    color: ${themeGet("colors.primary.hoverColor", lighten("#1b4aa8", 0.125))};
  }
  
  /* Style system support */
  ${space}
`;

ButtonLinkStyle.propTypes = {
  ...propTypes.space,
};

export { ButtonLinkStyle };
